import { useCallback, useEffect, useMemo, useState } from 'react';
import { AxiosResponseHeaders } from 'axios';
import useQuery from 'hooks/useQuery';

import { formatPaymentRecords } from '../helper';
import { HotcashTableColumn, PaymentRecord } from '../types';

const usePaymentRecords = (args?: Record<string, string | undefined>) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);

  const options = useMemo(
    () => ({
      params: {
        'paymentType.equals': 'cash',
        page: currentPage - 1,
        size: pageSize,
        ...args,
      },
    }),
    [currentPage, pageSize, args],
  );

  const handlePageChange = useCallback((page: number, size: number) => {
    setCurrentPage(page);
    setPageSize(size);
  }, []);

  const seasonIdx = args?.['seasonTypeId.equals'];

  const { data, isLoading, error, setData, refetch, headers } = useQuery<
    HotcashTableColumn[]
  >('collection', options, !!seasonIdx);

  useEffect(() => {
    const rHeaders = headers as AxiosResponseHeaders;
    const total = rHeaders?.get('X-Total-Count');
    if (data) setTotal(parseInt(total as string));
    else setTotal(0);
  }, [data, error, headers]);

  return {
    isLoading,
    data: formatPaymentRecords(data as unknown as PaymentRecord[]),
    error,
    currentPage,
    pageSize,
    total,
    handlePageChange,
    setData,
    refetch,
  };
};

export default usePaymentRecords;
